import { Component } from "react"

/* Components */
import { InnerLayout } from "../../components"

/* Modal */
import Modal from "react-modal"

/* Helpers */
import { utils } from "../../helpers"

/* Widgets */
import StudioVideo from "./StudioVideo"
import StudioRoom from "./StudioRoom"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { view } from "../../api/Livekit"



/* Widget Studio Stream */
class StudioStream extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            serviceURL: "",
            recordURL: "",
            data: null,
            rooms: [],
            status: "loading",
        }

        this._timer = null
    }

    /* Open Action */
    open = ({ serviceURL, recordURL }) => {

        this.setState({ visible: true, serviceURL, recordURL }, () => {

            this.load()

            this._timer = setInterval(() => {
                this.check()
            }, 15000)
        })
    }

    /* Close */
    close = () => {

        this.setState({ visible: false, serviceURL: "", recordURL: "", status: "loading", data: null })

        if (this._timer) {
            clearInterval(this._timer)
            this._timer = null
        }
    }

    /* Load Action */
    load = (reload = false) => {

        /* Fields */
        const { serviceURL } = this.state

        /* Check Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Send to REST API */
        view(serviceURL).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data, rooms: response.data._rooms })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: null, rooms: [] })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: null, rooms: [] })
            }
            else {
                this.setState({ status: "error", data: null, rooms: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: null, rooms: [] })
        })
    }

    /* Check Action */
    check = () => {

        /* Fields */
        const { serviceURL } = this.state

        /* Send to REST API */
        view(serviceURL).then((response) => {
            if (response.status === 200) {
                this.setState({ data: response.data, rooms: response.data._rooms })
            }
        })
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status, data, rooms, serviceURL, recordURL } = this.state

        /* Layout */
        if (status !== "ok") {
            return <InnerLayout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="studio--stream-content">

                <div className="studio--stream-metrics">

                    <div className="studio--stream-metric-container">

                        {/* Rooms */}
                        <div className="studio--stream-metric">
                            <img src="/metrics/live.png" alt="Live" />
                            <div className="studio--stream-metric-inner">
                                <div className="studio--stream-metric-inner-text">{t("studio.streams")}</div>
                                <div className="studio--stream-metric-inner-value">{utils.checkValue(data.rooms, "")}</div>
                            </div>
                        </div>

                        {/* Viewers */}
                        <div className="studio--stream-metric">
                            <img src="/metrics/follow.png" alt="Follow" />
                            <div className="studio--stream-metric-inner">
                                <div className="studio--stream-metric-inner-text">{t("studio.participants")}</div>
                                <div className="studio--stream-metric-inner-value">{utils.checkValue(data.viewers, "")}</div>
                            </div>
                        </div>

                    </div>

                    <div className="studio--stream-metric-container">

                        {/* Video */}
                        <div className="studio--stream-metric">
                            <img src="/metrics/video.png" alt="Video" />
                            <div className="studio--stream-metric-inner">
                                <div className="studio--stream-metric-inner-text">{t("studio.video")}</div>
                                <div className="studio--stream-metric-inner-value">{utils.checkValue(data.tracks?.video, "")}</div>
                            </div>
                        </div>

                        {/* Audio */}
                        <div className="studio--stream-metric">
                            <img src="/metrics/audio.png" alt="Audio" />
                            <div className="studio--stream-metric-inner">
                                <div className="studio--stream-metric-inner-text">{t("studio.audio")}</div>
                                <div className="studio--stream-metric-inner-value">{utils.checkValue(data.tracks?.audio, "")}</div>
                            </div>
                        </div>

                    </div>

                    <div className="studio--stream-metric-container">

                        {/* Upload */}
                        <div className="studio--stream-metric">
                            <img src="/metrics/arrows.png" alt="Arrows" />
                            <div className="studio--stream-metric-inner">
                                <div className="studio--stream-metric-inner-text">Upload</div>
                                <div className="studio--stream-metric-small-text">{t("studio.allTime")}</div>
                                <div className="studio--stream-metric-inner-value small">{utils.checkValue(data.traffic?.rx, "")}</div>
                            </div>
                        </div>

                        {/* Download */}
                        <div className="studio--stream-metric">
                            <img src="/metrics/arrows.png" alt="Arrows" />
                            <div className="studio--stream-metric-inner">
                                <div className="studio--stream-metric-inner-text">Download</div>
                                <div className="studio--stream-metric-small-text">{t("studio.allTime")}</div>
                                <div className="studio--stream-metric-inner-value small">{utils.checkValue(data.traffic?.tx, "")}</div>
                            </div>
                        </div>

                    </div>

                    <div className="studio--stream-metric-container">

                        {/* Video */}
                        <div className="studio--stream-metric">
                            <img src="/metrics/speed.png" alt="Speed" />
                            <div className="studio--stream-metric-inner">
                                <div className="studio--stream-metric-inner-text">Upload Speed</div>
                                <div className="studio--stream-metric-inner-value small">{utils.checkValue(data.traffic?.rxSpeed, "")}</div>
                            </div>
                        </div>

                        {/* Audio */}
                        <div className="studio--stream-metric">
                            <img src="/metrics/speed.png" alt="Audio" />
                            <div className="studio--stream-metric-inner">
                                <div className="studio--stream-metric-inner-text">Download Speed</div>
                                <div className="studio--stream-metric-inner-value small">{utils.checkValue(data.traffic?.txSpeed, "")}</div>
                            </div>
                        </div>

                    </div>


                    <div className="studio--stream-metric-container">

                        {/* CPU */}
                        <div className="studio--stream-metric">
                            <img src="/metrics/cpu.png" alt="CPU" />
                            <div className="studio--stream-metric-inner">
                                <div className="studio--stream-metric-inner-text">CPU 1min</div>
                                <div className="studio--stream-metric-inner-value small">{utils.checkValue(data.cpu?.load1m, "")}</div>
                            </div>
                        </div>

                        {/* CPU */}
                        <div className="studio--stream-metric">
                            <img src="/metrics/cpu.png" alt="CPU" />
                            <div className="studio--stream-metric-inner">
                                <div className="studio--stream-metric-inner-text">CPU 5min</div>
                                <div className="studio--stream-metric-inner-value small">{utils.checkValue(data.cpu?.load5m, "")}</div>
                            </div>
                        </div>

                    </div>


                    <div className="studio--stream-metric-container">

                        {/* CPU */}
                        <div className="studio--stream-metric">
                            <img src="/metrics/cpu.png" alt="CPU" />
                            <div className="studio--stream-metric-inner">
                                <div className="studio--stream-metric-inner-text">CPU 15min</div>
                                <div className="studio--stream-metric-inner-value small">{utils.checkValue(data.cpu?.load15m, "")}</div>
                            </div>
                        </div>

                        {/* CPU */}
                        <div className="studio--stream-metric">
                            <img src="/metrics/cpu-text.png" alt="CPU" />
                            <div className="studio--stream-metric-inner">
                                <div className="studio--stream-metric-inner-text">CPU CORE</div>
                                <div className="studio--stream-metric-inner-value small">{utils.checkValue(data.cpu?.cores, "")}</div>
                            </div>
                        </div>

                    </div>

                    <div className="studio--stream-metric-container">

                        {/* CPU */}
                        <div className="studio--stream-metric">
                            <img src="/metrics/server.png" alt="CPU" />
                            <div className="studio--stream-metric-inner">
                                <div className="studio--stream-metric-inner-text">{t("studio.load")}</div>
                                <div className="studio--stream-metric-inner-value small">{utils.checkBoolean(data.cpu?.overloaded) ? t("studio.yes") : t("studio.no")}</div>
                            </div>
                        </div>

                        {/* Archive */}
                        <div className="studio--stream-metric">
                            <img src="/metrics/video.png" alt="Video" />
                            <div className="studio--stream-metric-inner">
                                <div className="studio--stream-metric-inner-text">Archive</div>
                                <div className="studio--stream-metric-inner-value small">
                                    <a target="blank" href={`${recordURL}`}>Open Link</a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                {rooms && Array.isArray(rooms) && rooms.length > 0 &&
                    <div className="studio--stream-videos">
                        {rooms.map((item, index) =>
                            <div className="studio--stream-video" key={`${index}`}>

                                <StudioVideo socketURL={utils.checkValue(data.socketURL, "")} token={utils.checkValue(item.token, "")} />

                                <div onClick={() => this._room.open({ serviceURL, room: utils.checkValue(item.name, "") })} className="studio--stream-video-info">
                                    <div className="studio--stream-video-name">{utils.checkValue(item.name, "")}</div>
                                    <div className="studio--stream-video-viewers">
                                        <img src="/metrics/group.png" alt="Follow" />
                                        <span>{utils.checkValue(item.viewers, "")}</span>
                                    </div>
                                    <img src="/metrics/right-arrow.png" alt="Follow" />
                                </div>

                            </div>
                        )}
                    </div>
                }

            </div>
        )
    }

    render = () => {

        const { visible } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="studio--stream-modal"
                overlayClassName="studio--stream-overlay"
                closeTimeoutMS={200}
            >

                <div className="studio--stream-modal-header">
                    <h2>{t("studio.streams")}</h2>
                    <div onClick={() => this.close()} className="studio--stream-modal-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                {/* Draw Content */}
                {this._content()}

                {/* Draw Room */}
                <StudioRoom ref={(ref) => this._room = ref} />

            </Modal>
        )
    }
}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(StudioStream)